import { render, staticRenderFns } from "./Othreceivables.vue?vue&type=template&id=5e09e7f6"
import script from "./Othreceivables.vue?vue&type=script&lang=js"
export * from "./Othreceivables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports